var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('logo-loading'),_c('nav-component'),_c('b-container',{attrs:{"fluid":""}},[_c('router-view'),_c('cookies'),_c('footer-component')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }